// DS: IL11.5
import React from 'react';
export class Exclusives extends React.PureComponent {
    render() {
        return /*#__PURE__*/ React.createElement("img", {
            alt: "",
            src: "https://st.deviantart.net/eclipse/global/svg/il11-5.svg",
            width: "140",
            height: "140"
        });
    }
}

//# sourceMappingURL=Exclusives.js.map